import { Link, NavLink } from "react-router-dom";
import defaultProfilePic from "../../../assets/images/profile.png";
import { useAuthStore } from "../../../store";

interface SidebarInterface {
  sidebarOpen: boolean;
  setSidebarOpen: (x: boolean) => void;
}

const Sidebar: React.FC<SidebarInterface> = ({
  sidebarOpen,
  setSidebarOpen,
}) => {
  const [token, user] = useAuthStore((state) => [state.token, state.user]);
  return (
    <div className="text-gray-800 bg-gray-100 lg:flex font-dm-sans">
      <div
        onClick={() => setSidebarOpen(false)}
        className={
          "fixed inset-0 z-20 transition-opacity bg-black opacity-50 lg:hidden " +
          (sidebarOpen ? "block" : "hidden")
        }
      ></div>

      <div
        className={
          "fixed inset-y-0 right-0 z-30 flex flex-col h-screen overflow-y-auto transition duration-200 transform bg-white border-r border-gray-200 w-80 lg:w-64 2xl:w-72 lg:translate-x-0 lg:relative lg:inset-0 " +
          (sidebarOpen ? "translate-x-0 ease-in" : "translate-x-full ease-out")
        }
      >
        <div className="flex items-center justify-between px-6 py-12">
          <div className="flex items-center space-x-4">
            <span className="p-2 text-white lg:p-2.5 rounded-xl bg-primary">
              <svg
                width="20"
                height="20"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_860_2610)">
                  <path
                    d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                  <path
                    d="M12.9332 10.0003C12.8444 10.2014 12.818 10.4245 12.8572 10.6407C12.8964 10.857 12.9995 11.0565 13.1532 11.2137L13.1932 11.2537C13.3171 11.3775 13.4155 11.5245 13.4826 11.6864C13.5497 11.8483 13.5842 12.0218 13.5842 12.197C13.5842 12.3722 13.5497 12.5457 13.4826 12.7076C13.4155 12.8694 13.3171 13.0165 13.1932 13.1403C13.0693 13.2643 12.9223 13.3626 12.7604 13.4297C12.5986 13.4968 12.4251 13.5314 12.2498 13.5314C12.0746 13.5314 11.9011 13.4968 11.7392 13.4297C11.5774 13.3626 11.4303 13.2643 11.3065 13.1403L11.2665 13.1003C11.1094 12.9466 10.9098 12.8435 10.6936 12.8043C10.4773 12.7651 10.2542 12.7916 10.0532 12.8803C9.85599 12.9648 9.68783 13.1052 9.56937 13.284C9.45092 13.4629 9.38736 13.6725 9.3865 13.887V14.0003C9.3865 14.3539 9.24603 14.6931 8.99598 14.9431C8.74593 15.1932 8.40679 15.3337 8.05317 15.3337C7.69955 15.3337 7.36041 15.1932 7.11036 14.9431C6.86031 14.6931 6.71984 14.3539 6.71984 14.0003V13.9403C6.71468 13.7197 6.64325 13.5057 6.51484 13.3261C6.38644 13.1466 6.20699 13.0098 5.99984 12.9337C5.79876 12.8449 5.57571 12.8184 5.35944 12.8577C5.14318 12.8969 4.94362 13 4.7865 13.1537L4.7465 13.1937C4.62267 13.3176 4.47562 13.416 4.31376 13.4831C4.15189 13.5502 3.97839 13.5847 3.80317 13.5847C3.62795 13.5847 3.45445 13.5502 3.29258 13.4831C3.13072 13.416 2.98367 13.3176 2.85984 13.1937C2.73587 13.0698 2.63752 12.9228 2.57042 12.7609C2.50333 12.599 2.46879 12.4255 2.46879 12.2503C2.46879 12.0751 2.50333 11.9016 2.57042 11.7397C2.63752 11.5779 2.73587 11.4308 2.85984 11.307L2.89984 11.267C3.05353 11.1099 3.15663 10.9103 3.19584 10.6941C3.23505 10.4778 3.20858 10.2547 3.11984 10.0537C3.03533 9.85648 2.89501 9.68831 2.71615 9.56986C2.53729 9.45141 2.32769 9.38785 2.11317 9.38699H1.99984C1.64622 9.38699 1.30708 9.24652 1.05703 8.99647C0.80698 8.74642 0.666504 8.40728 0.666504 8.05366C0.666504 7.70004 0.80698 7.3609 1.05703 7.11085C1.30708 6.8608 1.64622 6.72033 1.99984 6.72033H2.05984C2.2805 6.71516 2.49451 6.64374 2.67404 6.51533C2.85357 6.38693 2.99031 6.20748 3.0665 6.00033C3.15525 5.79925 3.18172 5.5762 3.14251 5.35993C3.10329 5.14367 3.00019 4.94411 2.8465 4.78699L2.8065 4.74699C2.68254 4.62316 2.58419 4.47611 2.51709 4.31425C2.44999 4.15238 2.41545 3.97888 2.41545 3.80366C2.41545 3.62844 2.44999 3.45494 2.51709 3.29307C2.58419 3.13121 2.68254 2.98416 2.8065 2.86033C2.93033 2.73636 3.07739 2.63801 3.23925 2.57091C3.40111 2.50381 3.57462 2.46928 3.74984 2.46928C3.92506 2.46928 4.09856 2.50381 4.26042 2.57091C4.42229 2.63801 4.56934 2.73636 4.69317 2.86033L4.73317 2.90033C4.89029 3.05402 5.08985 3.15712 5.30611 3.19633C5.52237 3.23554 5.74543 3.20907 5.9465 3.12033H5.99984C6.19702 3.03582 6.36518 2.8955 6.48363 2.71664C6.60208 2.53778 6.66565 2.32818 6.6665 2.11366V2.00033C6.6665 1.6467 6.80698 1.30756 7.05703 1.05752C7.30708 0.807468 7.64621 0.666992 7.99984 0.666992C8.35346 0.666992 8.6926 0.807468 8.94265 1.05752C9.19269 1.30756 9.33317 1.6467 9.33317 2.00033V2.06033C9.33403 2.27485 9.39759 2.48444 9.51604 2.6633C9.63449 2.84216 9.80266 2.98248 9.99984 3.06699C10.2009 3.15574 10.424 3.18221 10.6402 3.143C10.8565 3.10378 11.0561 3.00068 11.2132 2.84699L11.2532 2.80699C11.377 2.68302 11.5241 2.58468 11.6859 2.51758C11.8478 2.45048 12.0213 2.41594 12.1965 2.41594C12.3717 2.41594 12.5452 2.45048 12.7071 2.51758C12.869 2.58468 13.016 2.68302 13.1398 2.80699C13.2638 2.93082 13.3622 3.07787 13.4292 3.23974C13.4963 3.4016 13.5309 3.5751 13.5309 3.75033C13.5309 3.92555 13.4963 4.09905 13.4292 4.26091C13.3622 4.42278 13.2638 4.56983 13.1398 4.69366L13.0998 4.73366C12.9461 4.89078 12.843 5.09034 12.8038 5.3066C12.7646 5.52286 12.7911 5.74591 12.8798 5.94699V6.00033C12.9643 6.1975 13.1047 6.36567 13.2835 6.48412C13.4624 6.60257 13.672 6.66614 13.8865 6.66699H13.9998C14.3535 6.66699 14.6926 6.80747 14.9426 7.05752C15.1927 7.30756 15.3332 7.6467 15.3332 8.00033C15.3332 8.35395 15.1927 8.69309 14.9426 8.94313C14.6926 9.19318 14.3535 9.33366 13.9998 9.33366H13.9398C13.7253 9.33451 13.5157 9.39808 13.3369 9.51653C13.158 9.63498 13.0177 9.80315 12.9332 10.0003V10.0003Z"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_860_2610">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </span>

            <div className="font-bold ">
              <p className="text-sm text-gray-500">Open</p>
              <p className="text-sm text-gray-800">Config</p>
            </div>
          </div>

          <button
            onClick={() => setSidebarOpen(false)}
            className="text-gray-600 lg:hidden focus:text-primary focus:outline-none"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.5 4.5L4.5 13.5"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M4.5 4.5L13.5 13.5"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>

        <nav className="flex-1 px-6 space-y-3">
          <NavLink
            to="/release-note"
            className={({ isActive }) =>
              `flex items-center px-4 py-3 space-x-3  transition-colors duration-200 transform rounded-lg hover:text-gray-600  bg-opacity-40 ${
                isActive
                  ? "text-gray-600 bg-gray-200"
                  : "text-gray-500 hover:bg-gray-100"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g opacity={isActive ? "1" : "0.5"}>
                    <path
                      d="M10.5 1.5H4.5C4.10218 1.5 3.72064 1.65804 3.43934 1.93934C3.15804 2.22064 3 2.60218 3 3V15C3 15.3978 3.15804 15.7794 3.43934 16.0607C3.72064 16.342 4.10218 16.5 4.5 16.5H13.5C13.8978 16.5 14.2794 16.342 14.5607 16.0607C14.842 15.7794 15 15.3978 15 15V6L10.5 1.5Z"
                      stroke="black"
                      strokeLinecap="round"
                    />
                    <path
                      d="M10.5 1.5V6H15"
                      stroke="black"
                      strokeLinecap="round"
                    />
                    <path d="M12 9.75H6" stroke="black" strokeLinecap="round" />
                    <path
                      d="M12 12.75H6"
                      stroke="black"
                      strokeLinecap="round"
                    />
                    <path
                      d="M7.5 6.75H6.75H6"
                      stroke="black"
                      strokeLinecap="round"
                    />
                  </g>
                </svg>

                <span
                  className={`capitalize ${isActive ? "text-gray-800" : ""}`}
                >
                  Release Notes
                </span>
              </>
            )}
          </NavLink>

          <NavLink
            to="/localization/projects"
            className={({ isActive }) =>
              `flex items-center px-4 py-3 space-x-3  transition-colors duration-200 transform rounded-lg hover:text-gray-600  bg-opacity-40 ${
                isActive
                  ? "text-gray-600 bg-gray-200"
                  : "text-gray-500 hover:bg-gray-100"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g opacity={isActive ? "1" : "0.5"}>
                    <path
                      d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
                      stroke="black"
                      strokeLinecap="round"
                    />
                    <path
                      d="M1.5 9H16.5"
                      stroke="black"
                      strokeLinecap="round"
                    />
                    <path
                      d="M9 1.5C10.876 3.55376 11.9421 6.21903 12 9C11.9421 11.781 10.876 14.4462 9 16.5C7.12404 14.4462 6.05794 11.781 6 9C6.05794 6.21903 7.12404 3.55376 9 1.5V1.5Z"
                      stroke="black"
                      strokeLinecap="round"
                    />
                  </g>
                </svg>

                <span
                  className={`capitalize ${isActive ? "text-gray-800" : ""}`}
                >
                  Localization
                </span>
              </>
            )}
          </NavLink>

          <NavLink
            to="/usage-analytics/projects"
            className={({ isActive }) =>
              `flex items-center px-4 py-3 space-x-3  transition-colors duration-200 transform rounded-lg hover:text-gray-600  bg-opacity-40 ${
                isActive
                  ? "text-gray-600 bg-gray-200"
                  : "text-gray-500 hover:bg-gray-100"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g opacity={isActive ? "1" : "0.5"}>
                    <path
                      d="M16.5 8.31002V9.00002C16.4991 10.6173 15.9754 12.191 15.007 13.4864C14.0386 14.7818 12.6775 15.7294 11.1265 16.1879C9.57557 16.6465 7.91794 16.5914 6.40085 16.031C4.88376 15.4705 3.58849 14.4346 2.70822 13.0778C1.82795 11.721 1.40984 10.1161 1.51626 8.50226C1.62267 6.88844 2.24791 5.35227 3.29871 4.12283C4.34951 2.89339 5.76959 2.03656 7.34714 1.68013C8.92469 1.3237 10.5752 1.48677 12.0525 2.14502"
                      stroke="black"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M16.5 3L9 10.5075L6.75 8.2575"
                      stroke="black"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                </svg>

                <span
                  className={`capitalize ${isActive ? "text-gray-800" : ""}`}
                >
                  Usage Analytics
                </span>
              </>
            )}
          </NavLink>

          <NavLink
            to="/notifications/projects"
            className={({ isActive }) =>
              `flex items-center px-4 py-3 space-x-3  transition-colors duration-200 transform rounded-lg hover:text-gray-600  bg-opacity-40 ${
                isActive
                  ? "text-gray-600 bg-gray-200"
                  : "text-gray-500 hover:bg-gray-100"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g opacity={isActive ? "1" : "0.5"}>
                    <path
                      d="M13.5 6C13.5 4.80653 13.0259 3.66193 12.182 2.81802C11.3381 1.97411 10.1935 1.5 9 1.5C7.80653 1.5 6.66193 1.97411 5.81802 2.81802C4.97411 3.66193 4.5 4.80653 4.5 6C4.5 11.25 2.25 12.75 2.25 12.75H15.75C15.75 12.75 13.5 11.25 13.5 6Z"
                      stroke="black"
                      strokeLinecap="round"
                    />
                    <path
                      d="M10.2976 15.75C10.1658 15.9773 9.97652 16.166 9.74881 16.2971C9.52109 16.4283 9.26292 16.4973 9.00014 16.4973C8.73735 16.4973 8.47918 16.4283 8.25147 16.2971C8.02375 16.166 7.83449 15.9773 7.70264 15.75"
                      stroke="black"
                      strokeLinecap="round"
                    />
                  </g>
                </svg>

                <span
                  className={`capitalize ${isActive ? "text-gray-800" : ""}`}
                >
                  Notifications
                </span>
              </>
            )}
          </NavLink>

          <NavLink
            to="/configurations"
            className={({ isActive }) =>
              `flex items-center px-4 py-3 space-x-3  transition-colors duration-200 transform rounded-lg hover:text-gray-600  bg-opacity-40 ${
                isActive
                  ? "text-gray-600 bg-gray-200"
                  : "text-gray-500 hover:bg-gray-100"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g opacity={isActive ? "1" : "0.5"}>
                    <path
                      d="M11.025 4.7248C10.8876 4.865 10.8106 5.05349 10.8106 5.2498C10.8106 5.44612 10.8876 5.6346 11.025 5.7748L12.225 6.9748C12.3652 7.11222 12.5537 7.18919 12.75 7.18919C12.9463 7.18919 13.1348 7.11222 13.275 6.9748L16.1025 4.1473C16.4796 4.98069 16.5938 5.90923 16.4299 6.80916C16.2659 7.70909 15.8315 8.53768 15.1847 9.18451C14.5379 9.83134 13.7093 10.2657 12.8094 10.4296C11.9094 10.5936 10.9809 10.4794 10.1475 10.1023L4.96501 15.2848C4.66664 15.5832 4.26197 15.7508 3.84001 15.7508C3.41806 15.7508 3.01338 15.5832 2.71501 15.2848C2.41665 14.9864 2.24902 14.5818 2.24902 14.1598C2.24902 13.7378 2.41665 13.3332 2.71501 13.0348L7.89751 7.8523C7.52039 7.01891 7.4062 6.09038 7.57017 5.19044C7.73414 4.29051 8.16848 3.46192 8.8153 2.81509C9.46213 2.16827 10.2907 1.73393 11.1907 1.56996C12.0906 1.40599 13.0191 1.52018 13.8525 1.8973L11.0325 4.7173L11.025 4.7248Z"
                      stroke="black"
                      strokeLinecap="round"
                    />
                  </g>
                </svg>

                <span
                  className={`capitalize ${isActive ? "text-gray-800" : ""}`}
                >
                  Configurations
                </span>
              </>
            )}
          </NavLink>

          <NavLink
            to="/members"
            className={({ isActive }) =>
              `flex items-center px-4 py-3 space-x-3  transition-colors duration-200 transform rounded-lg hover:text-gray-600  bg-opacity-40 ${
                isActive
                  ? "text-gray-600 bg-gray-200"
                  : "text-gray-500 hover:bg-gray-100"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g opacity={isActive ? "1" : "0.5"}>
                    <path
                      d="M12.75 15.75V14.25C12.75 13.4544 12.4339 12.6913 11.8713 12.1287C11.3087 11.5661 10.5456 11.25 9.75 11.25H3.75C2.95435 11.25 2.19129 11.5661 1.62868 12.1287C1.06607 12.6913 0.75 13.4544 0.75 14.25V15.75"
                      stroke="black"
                      strokeLinecap="round"
                    />
                    <path
                      d="M6.75 8.25C8.40685 8.25 9.75 6.90685 9.75 5.25C9.75 3.59315 8.40685 2.25 6.75 2.25C5.09315 2.25 3.75 3.59315 3.75 5.25C3.75 6.90685 5.09315 8.25 6.75 8.25Z"
                      stroke="black"
                      strokeLinecap="round"
                    />
                    <path
                      d="M17.25 15.7502V14.2502C17.2495 13.5855 17.0283 12.9397 16.621 12.4144C16.2138 11.889 15.6436 11.5138 15 11.3477"
                      stroke="black"
                      strokeLinecap="round"
                    />
                    <path
                      d="M12 2.34766C12.6453 2.51288 13.2173 2.88818 13.6257 3.41439C14.0342 3.9406 14.2559 4.58778 14.2559 5.25391C14.2559 5.92003 14.0342 6.56722 13.6257 7.09342C13.2173 7.61963 12.6453 7.99493 12 8.16016"
                      stroke="black"
                      strokeLinecap="round"
                    />
                  </g>
                </svg>

                <span
                  className={`capitalize ${isActive ? "text-gray-800" : ""}`}
                >
                  Members
                </span>
              </>
            )}
          </NavLink>

          <NavLink
            to="/audit-logs"
            className={({ isActive }) =>
              `flex items-center px-4 py-3 space-x-3  transition-colors duration-200 transform rounded-lg hover:text-gray-600  bg-opacity-40 ${
                isActive
                  ? "text-gray-600 bg-gray-200"
                  : "text-gray-500 hover:bg-gray-100"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g opacity={isActive ? "1" : "0.5"}>
                    <path
                      d="M16.5 8.31002V9.00002C16.4991 10.6173 15.9754 12.191 15.007 13.4864C14.0386 14.7818 12.6775 15.7294 11.1265 16.1879C9.57557 16.6465 7.91794 16.5914 6.40085 16.031C4.88376 15.4705 3.58849 14.4346 2.70822 13.0778C1.82795 11.721 1.40984 10.1161 1.51626 8.50226C1.62267 6.88844 2.24791 5.35227 3.29871 4.12283C4.34951 2.89339 5.76959 2.03656 7.34714 1.68013C8.92469 1.3237 10.5752 1.48677 12.0525 2.14502"
                      stroke="black"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M16.5 3L9 10.5075L6.75 8.2575"
                      stroke="black"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <circle
                      cx="9"
                      cy="9"
                      r="4"
                      stroke="black"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                </svg>

                <span
                  className={`capitalize ${isActive ? "text-gray-800" : ""}`}
                >
                  Audit Logs
                </span>
              </>
            )}
          </NavLink>
          <NavLink
            to="/ai"
            className={({ isActive }) =>
              `flex items-center px-4 py-3 space-x-3  transition-colors duration-200 transform rounded-lg hover:text-gray-600  bg-opacity-40 ${
                isActive
                  ? "text-gray-600 bg-gray-200"
                  : "text-gray-500 hover:bg-gray-100"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 0 1-.825-.242m9.345-8.334a2.126 2.126 0 0 0-.476-.095 48.64 48.64 0 0 0-8.048 0c-1.131.094-1.976 1.057-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0 0 11.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155"
                  />
                </svg>

                <span
                  className={`capitalize ${isActive ? "text-gray-800" : ""}`}
                >
                  AI Models
                </span>
              </>
            )}
          </NavLink>

          {/* <NavLink
            to="/admins/users"
            className={({ isActive }) =>
              `flex items-center px-4 py-3 space-x-3  transition-colors duration-200 transform rounded-lg hover:text-gray-600  bg-opacity-40 ${
                isActive
                  ? "text-gray-600 bg-gray-200"
                  : "text-gray-500 hover:bg-gray-100"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g
                    opacity={isActive ? "1" : "0.5"}
                    clipPath="url(#clip0_860_2593)"
                  >
                    <path
                      d="M9 11.25C10.2426 11.25 11.25 10.2426 11.25 9C11.25 7.75736 10.2426 6.75 9 6.75C7.75736 6.75 6.75 7.75736 6.75 9C6.75 10.2426 7.75736 11.25 9 11.25Z"
                      stroke="black"
                      strokeLinecap="round"
                    />
                    <path
                      d="M14.55 11.25C14.4502 11.4762 14.4204 11.7271 14.4645 11.9704C14.5086 12.2137 14.6246 12.4382 14.7975 12.615L14.8425 12.66C14.982 12.7993 15.0926 12.9647 15.1681 13.1468C15.2436 13.3289 15.2824 13.5241 15.2824 13.7213C15.2824 13.9184 15.2436 14.1136 15.1681 14.2957C15.0926 14.4778 14.982 14.6432 14.8425 14.7825C14.7032 14.922 14.5378 15.0326 14.3557 15.1081C14.1736 15.1836 13.9784 15.2224 13.7812 15.2224C13.5841 15.2224 13.3889 15.1836 13.2068 15.1081C13.0247 15.0326 12.8593 14.922 12.72 14.7825L12.675 14.7375C12.4982 14.5646 12.2737 14.4486 12.0304 14.4045C11.7871 14.3604 11.5362 14.3902 11.31 14.49C11.0882 14.5851 10.899 14.7429 10.7657 14.9442C10.6325 15.1454 10.561 15.3812 10.56 15.6225V15.75C10.56 16.1478 10.402 16.5294 10.1207 16.8107C9.83936 17.092 9.45782 17.25 9.06 17.25C8.66218 17.25 8.28064 17.092 7.99934 16.8107C7.71804 16.5294 7.56 16.1478 7.56 15.75V15.6825C7.55419 15.4343 7.47384 15.1935 7.32938 14.9915C7.18493 14.7896 6.98305 14.6357 6.75 14.55C6.52379 14.4502 6.27286 14.4204 6.02956 14.4645C5.78626 14.5086 5.56176 14.6246 5.385 14.7975L5.34 14.8425C5.20069 14.982 5.03526 15.0926 4.85316 15.1681C4.67106 15.2436 4.47587 15.2824 4.27875 15.2824C4.08163 15.2824 3.88644 15.2436 3.70434 15.1681C3.52224 15.0926 3.35681 14.982 3.2175 14.8425C3.07804 14.7032 2.9674 14.5378 2.89191 14.3557C2.81642 14.1736 2.77757 13.9784 2.77757 13.7812C2.77757 13.5841 2.81642 13.3889 2.89191 13.2068C2.9674 13.0247 3.07804 12.8593 3.2175 12.72L3.2625 12.675C3.4354 12.4982 3.55139 12.2737 3.5955 12.0304C3.63962 11.7871 3.60984 11.5362 3.51 11.31C3.41493 11.0882 3.25707 10.899 3.05585 10.7657C2.85463 10.6325 2.61884 10.561 2.3775 10.56H2.25C1.85218 10.56 1.47064 10.402 1.18934 10.1207C0.908035 9.83936 0.75 9.45782 0.75 9.06C0.75 8.66218 0.908035 8.28064 1.18934 7.99934C1.47064 7.71804 1.85218 7.56 2.25 7.56H2.3175C2.56575 7.55419 2.8065 7.47384 3.00847 7.32938C3.21045 7.18493 3.36429 6.98305 3.45 6.75C3.54984 6.52379 3.57962 6.27286 3.5355 6.02956C3.49139 5.78626 3.3754 5.56176 3.2025 5.385L3.1575 5.34C3.01804 5.20069 2.9074 5.03526 2.83191 4.85316C2.75642 4.67106 2.71757 4.47587 2.71757 4.27875C2.71757 4.08163 2.75642 3.88644 2.83191 3.70434C2.9074 3.52224 3.01804 3.35681 3.1575 3.2175C3.29681 3.07804 3.46224 2.9674 3.64434 2.89191C3.82644 2.81642 4.02163 2.77757 4.21875 2.77757C4.41587 2.77757 4.61106 2.81642 4.79316 2.89191C4.97526 2.9674 5.14069 3.07804 5.28 3.2175L5.325 3.2625C5.50176 3.4354 5.72626 3.55139 5.96956 3.5955C6.21285 3.63962 6.46379 3.60984 6.69 3.51H6.75C6.97183 3.41493 7.16101 3.25707 7.29427 3.05585C7.42753 2.85463 7.49904 2.61884 7.5 2.3775V2.25C7.5 1.85218 7.65804 1.47064 7.93934 1.18934C8.22064 0.908035 8.60218 0.75 9 0.75C9.39782 0.75 9.77936 0.908035 10.0607 1.18934C10.342 1.47064 10.5 1.85218 10.5 2.25V2.3175C10.501 2.55884 10.5725 2.79463 10.7057 2.99585C10.839 3.19707 11.0282 3.35493 11.25 3.45C11.4762 3.54984 11.7271 3.57962 11.9704 3.5355C12.2137 3.49139 12.4382 3.3754 12.615 3.2025L12.66 3.1575C12.7993 3.01804 12.9647 2.9074 13.1468 2.83191C13.3289 2.75642 13.5241 2.71757 13.7213 2.71757C13.9184 2.71757 14.1136 2.75642 14.2957 2.83191C14.4778 2.9074 14.6432 3.01804 14.7825 3.1575C14.922 3.29681 15.0326 3.46224 15.1081 3.64434C15.1836 3.82644 15.2224 4.02163 15.2224 4.21875C15.2224 4.41587 15.1836 4.61106 15.1081 4.79316C15.0326 4.97526 14.922 5.14069 14.7825 5.28L14.7375 5.325C14.5646 5.50176 14.4486 5.72626 14.4045 5.96956C14.3604 6.21285 14.3902 6.46379 14.49 6.69V6.75C14.5851 6.97183 14.7429 7.16101 14.9442 7.29427C15.1454 7.42753 15.3812 7.49904 15.6225 7.5H15.75C16.1478 7.5 16.5294 7.65804 16.8107 7.93934C17.092 8.22064 17.25 8.60218 17.25 9C17.25 9.39782 17.092 9.77936 16.8107 10.0607C16.5294 10.342 16.1478 10.5 15.75 10.5H15.6825C15.4412 10.501 15.2054 10.5725 15.0042 10.7057C14.8029 10.839 14.6451 11.0282 14.55 11.25V11.25Z"
                      stroke="black"
                      strokeLinecap="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_860_2593">
                      <rect width="18" height="18" fill="white" />
                    </clipPath>
                  </defs>
                </svg>

                <span
                  className={`capitalize ${isActive ? "text-gray-800" : ""}`}
                >
                  Settings
                </span>
              </>
            )}
          </NavLink> */}

          {/* <NavLink
            to="/admins/team-calender"
            className={({ isActive }) =>
              `flex items-center px-4 py-3 space-x-3  transition-colors duration-200 transform rounded-lg hover:text-gray-600  bg-opacity-40 ${
                isActive
                  ? "text-gray-600 bg-gray-200"
                  : "text-gray-500 hover:bg-gray-100"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g opacity={isActive ? "1" : "0.5"}>
                    <path
                      d="M3 11.25C3 11.25 3.75 10.5 6 10.5C8.25 10.5 9.75 12 12 12C14.25 12 15 11.25 15 11.25V2.25C15 2.25 14.25 3 12 3C9.75 3 8.25 1.5 6 1.5C3.75 1.5 3 2.25 3 2.25V11.25Z"
                      stroke="black"
                      strokeLinecap="round"
                    />
                    <path
                      d="M3 16.5V11.25"
                      stroke="black"
                      strokeLinecap="round"
                    />
                  </g>
                </svg>

                <span
                  className={`capitalize ${isActive ? "text-gray-800" : ""}`}
                >
                  Feature Flag
                </span>
              </>
            )}
          </NavLink> */}
        </nav>

        <hr className="my-6 border-gray-200" />

        <div className="px-6 pt-4 pb-10">
          <NavLink
            to="/profile"
            className="flex items-center mt-4 space-x-3 text-lg font-bold text-gray-800 hover:text-gray-700 hover:underline"
          >
            <img
              className="object-cover w-16 h-16 rounded-full"
              src={user.profilePic ? user.profilePic : defaultProfilePic}
              alt=""
            />
          </NavLink>

          <NavLink
            to="/profile"
            className="flex items-center mt-4 space-x-3 text-lg font-bold text-gray-800 hover:text-gray-700 hover:underline"
          >
            <span>{user.firstName + " " + user.lastName}</span>

            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-5 h-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M13 7l5 5m0 0l-5 5m5-5H6"
              />
            </svg>
          </NavLink>

          <p className="mt-1 text-sm text-gray-600">{user?.organizationName}</p>

          <Link
            to="/logout"
            className="flex items-center mt-4 space-x-3 font-bold text-gray-400 hover:text-gray-500 hover:underline"
          >
            <span>Log Out</span>

            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-5 h-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
              />
            </svg>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
